//import scripts for block
import '../../gutenberg/blocks/accordion/functions'
import '../../gutenberg/blocks/slider/frontend'
import '../../gutenberg/blocks/table-agenda-items/toggle'
import { Fancybox } from '@fancyapps/ui'

const initComparisons = parent => {
  if (!parent) return
  let x, i
  /* Find all elements with an "overlay" class: */
  x = parent.getElementsByClassName('img-comp-overlay')

  for (i = 0; i < x.length; i++) {
    compareImages(x[i], parent)
  }

  function compareImages(img, parent) {
    let slider,
      clicked = 0,
      w
    /* Get the width and height of the img element */
    w = img.offsetWidth
    /* Set the width of the img element to 50%: */
    img.style.width = w / 2 + 'px'
    /* Create slider: */
    slider = parent.getElementsByClassName('img-comp-slider')
    if (!slider.length) {
      slider = document.createElement('DIV')
      slider.setAttribute('class', 'img-comp-slider')
      /* Insert slider */
      img.parentElement.insertBefore(slider, img)
    }
    if (slider.style) {
      /* Position the slider in the middle: */
      slider.style.left = w / 2 - slider.offsetWidth / 2 + 'px'
      /* Execute a function when the mouse button is pressed: */
      slider.addEventListener('mousedown', slideReady)
      /* And another function when the mouse button is released: */
      window.addEventListener('mouseup', slideFinish)
      /* Or touched (for touch screens: */
      slider.addEventListener('touchstart', slideReady)
      /* And released (for touch screens: */
      window.addEventListener('touchend', slideFinish)
    }

    function slideReady(e) {
      /* Prevent any other actions that may occur when moving over the image: */
      e.preventDefault()
      /* The slider is now clicked and ready to move: */
      clicked = 1
      /* Execute a function when the slider is moved: */
      window.addEventListener('mousemove', slideMove)
      window.addEventListener('touchmove', slideMove)
    }

    function slideFinish() {
      /* The slider is no longer clicked: */
      clicked = 0
    }

    function slideMove(e) {
      let pos
      /* If the slider is no longer clicked, exit this function: */
      if (clicked == 0) return false
      /* Get the cursor's x position: */
      pos = getCursorPos(e)
      /* Prevent the slider from being positioned outside the image: */
      if (pos < 0) pos = 0
      if (pos > w) pos = w
      /* Execute a function that will resize the overlay image according to the cursor: */
      slide(pos)
    }

    function getCursorPos(e) {
      let a,
        x = 0
      e = e.changedTouches ? e.changedTouches[0] : e
      /* Get the x positions of the image: */
      a = img.getBoundingClientRect()
      /* Calculate the cursor's x coordinate, relative to the image: */
      x = e.pageX - a.left
      /* Consider any page scrolling: */
      x = x - window.pageXOffset
      return x
    }

    function slide(x) {
      /* Resize the image: */
      img.style.width = x + 'px'
      /* Position the slider: */
      slider.style.left = img.offsetWidth - slider.offsetWidth / 2 + 'px'
    }
  }
}

const updateComparisons = parent => {
  let slider = parent.getElementsByClassName('img-comp-slider')[0],
    img = parent.getElementsByClassName('img-comp-overlay')[0]

  img.style.width = '50%'
  slider.style.left = parent.offsetWidth / 2 - slider.offsetWidth / 2 + 'px'
}

const addRotation = () => {
  //add rotate option to fancybox
  let fancyMiddle = document.getElementsByClassName(
    'fancybox__toolbar__column is-middle'
  )
  if (fancyMiddle.length) {
    let rotate = 1
    //rotate active image on click
    fancyMiddle[0].addEventListener('click', () => {
      let fancyContent = document.getElementsByClassName(
          'fancybox__slide is-selected'
        ),
        fancyImage = fancyContent[0].getElementsByClassName('fancybox-image')
      if (fancyImage.length) {
        fancyImage[0].style.transform = `rotate(${90 * rotate++}deg)`
      }
    })
  }
}

// Check images comparison on page resize
window.addEventListener('resize', () => {
  let parentContainers = document.getElementsByClassName('image-comparison')
  for (let i = 0; i < parentContainers.length; i++) {
    updateComparisons(parentContainers[i])
  }
})

// check images comparison on page load
window.addEventListener('load', () => {
  let parentContainers = document.getElementsByClassName('image-comparison')
  for (let i = 0; i < parentContainers.length; i++) {
    let images = parentContainers[i].getElementsByClassName('comparison-image')

    if (
      images[0].complete &&
      images[0].naturalHeight !== 0 &&
      images[1]?.complete &&
      images[1]?.naturalHeight !== 0
    ) {
      initComparisons(parentContainers[i])
    }
    //update after initialize
    updateComparisons(parentContainers[i])
  }
})

document.addEventListener('DOMContentLoaded', function () {
  //enable fancybox
  Fancybox.bind('[data-fancybox]', {
    on: {
      done: () => {
        addRotation()
      },
    },
  })

  const getFancyboxcaptionWidth = fancybox => {
    if (!fancybox) return

    const slide = fancybox.getSlide()
    if (slide?.captionEl) {
      slide.captionEl.style.width =
        slide?.imageEl.width !== 0 ? slide.imageEl.width + 'px' : 'inherit'
    }
  }

  Fancybox.bind('.image-grid a', {
    groupAll: true,
    on: {
      'Carousel.change': fancybox => {
        getFancyboxcaptionWidth(fancybox)
      },
      reveal: fancybox => {
        getFancyboxcaptionWidth(fancybox)
      },
    },
  })
})

export default initComparisons
